<template>
    <div>
        <!-- <headLine></headLine> -->
        <div class="elder_manage_title">
            <p class="title">呼入电话统计</p>
        </div>
        <slot name="statistics"></slot>
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="Reset"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
                 <i class="searchDomw" @click="isSearchContent = !isSearchContent" :class="isSearchContent==true?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
            </div>
            <div class="search_content" v-show="isSearchContent">
                <div class="search_inline">
                    <el-form label-width="90px">
                        <el-row>
                            <el-col :span="10">
                                <el-form-item label="日期：">
                                    <div style="display: flex">
                                        <el-date-picker
                                            v-model="queryForm.startTime"
                                            type="datetime"
                                            format="yyyy-MM-dd HH:mm:ss"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="开始时间"
                                        >
                                        </el-date-picker>
                                        <div style="margin: 0 15px">至</div>
                                        <el-date-picker
                                            v-model="queryForm.endTime"
                                            type="datetime"
                                            format="yyyy-MM-dd HH:mm:ss"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="结束时间"
                                        >
                                        </el-date-picker>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-button
                                    type="primary"
                                    class="searchBtns"
                                    @click="getTableData"
                                    style="margin-left: 650px"
                                    >查询</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div>
            </div>
        </div>
        <!-- <global-tag>
      <span slot="title">呼入电话统计</span>
      <div class="search" slot="search">
        <el-form label-width="90px">
          <el-row>
            <el-col :span="10">
              <el-form-item label="日期：">
                <div style="display: flex;">
                  <el-date-picker
                      v-model="startTime"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="开始时间">
                  </el-date-picker>
                  <div style="margin: 0 15px;">至</div>
                  <el-date-picker
                      v-model="endTime"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="结束时间">
                  </el-date-picker>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5" :offset="2">
              <el-button type="primary" size="mini" @click="getTableData" style="margin-left: 650px;">查询</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </global-tag> -->

        <div class="jinxian-title">
            <div>
                <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    :header-cell-style="{
                        background: '#f2f2f2',
                        color: '#000',
                    }"
                >
                    <el-table-column
                        prop="date"
                        label="时间段"
                        width="300"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column prop="count" label="进线数" align="center">
                    </el-table-column>
                </el-table>
            </div>
            <div>
                <div ref="component" id="myChart1"></div>
            </div>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import globalTag from "../components/globalTag"
import headLine from "../components/headline"

export default {
    components: {
        globalTag,
        headLine,
    },
    data() {
        this.isEchart = ""
        return {
            queryForm: {},
            totalLsit: [],
            hourLsit: [],
            startTime: "",
            endTime: "",
            tableData: [
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
                {
                    date: "00:00:00",
                    count: "0",
                },
            ],
            isSearchContent: true,
        }
    },
    created() {
        //默认开始时间：7天前，结束时间: 当天！
        let now = new Date()
        let startDate = new Date(
            Date.UTC(now.getFullYear(), now.getMonth(), now.getDate() - 7)
        )
            .toISOString()
            .slice(0, 10)
        startDate =
            startDate +
            " " +
            now.getHours() +
            ":" +
            now.getMinutes() +
            ":" +
            now.getSeconds()
        let endDate = new Date(
            Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
        )
            .toISOString()
            .slice(0, 10)
        endDate =
            endDate +
            " " +
            now.getHours() +
            ":" +
            now.getMinutes() +
            ":" +
            now.getSeconds()
        console.log(startDate)
        console.log(endDate)
        this.startTime = startDate
        this.endTime = endDate
        this.getTableData()
    },
    mounted() {
        this.drawLine()
    },
    methods: {
        Reset() {
            this.queryForm = {}
            this.getTableData()
        },
        getTableData() {
            request({
                url: "/jjyl/callInfo/info/findCallInfo",
                method: "POST",
                data: {
                    startTime: this.queryForm.startTime,
                    endTime: this.queryForm.endTime,
                    belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
                    pageNo: 1,
                    pageSize: 9999,
                },
            }).then((res) => {
                if (res.code === 200 && res.content) {
                    this.tableData = res.content.list
                } else {
                    this.tableData = []
                }
            })
        },
        drawLine() {
            request({
                url: "/jjyl/ivrCallInfo/info/findIvrCallInfo",
                method: "POST",
                data: {
                    startTime: this.startTime,
                    endTime: this.endTime,
                    belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
                    pageSize: 9999,
                    pageNo: 1,
                },
            }).then((res) => {
                if (res.code === 200 && res.content) {
                    console.log("echarts", res)
                    this.totalLsit = content.list
                        .filter((isat) => {
                            if (isat.total) {
                                return isat.total
                            }
                        })
                        .map((isDate) => {
                            return isDate.total
                        })
                    this.hourLsit = content.list
                        .filter((isat) => {
                            if (isat.total) {
                                return isat.hour
                            }
                        })
                        .map((isDate) => {
                            return isDate.hour
                        })
                    // this.tableData = res.content.list
                } else {
                    // this.tableData = []
                }
            })

            let dataList = [12, 13, 14, 15, 16, 17]
            this.isEchart = this.$echarts.init(
                document.getElementById("myChart1")
            )
            this.$echarts.init(this.$refs.component, null, {
                renderer: "canvas",
            })
            // 绘制图表
            this.isEchart.setOption({
                tooltip: {
                    trigger: "axis",
                },
                xAxis: {
                    type: "category",
                    data: hourLsit,
                    // ['书法', '绘画', '料理', '羽毛球', '兵乓球', '其他'],
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        data: totalLsit,
                        type: "line",
                        itemStyle: {
                            normal: {
                                color: "#05b4f6",
                            },
                        },
                    },
                ],
            })
        },
    },
    beforeDestroy() {
        if (this.isEchart) {
            this.isEchart.clear()
        }
    },
}
</script>

<style lang="less" scoped>
.jinxian-title {
    width: 100%;
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
}

.jinxian-title > div {
    width: 49%;
}

#myChart1 {
    width: 100%;
    height: 660px;
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(151, 151, 151, .16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw{cursor: pointer;}
</style>
